import { useAtomValue, useSetAtom } from 'jotai'
import { LucideExternalLink, LucideX } from 'lucide-react'
import { Link, useLocation, useNavigate } from 'react-router'
import { aClient, aSelectedListing } from '~/atoms'
import { SelectionCheckbox } from '~/components/common'
import { ListingGallery, ListingMeta } from '~/components/listing'
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~/components/ui'
import useMapListingLink from '~/hooks/map/useMapListingLink'
import { cn } from '~/lib'
import type { Listing } from '~/models'
import { ListingInfo, ListingTabs } from './preview'

type MapPreviewListingProps = {
  className?: string
  listing: Listing
}

export default function MapPreviewListing(props: MapPreviewListingProps) {
  const { listing, className } = props
  const navigate = useNavigate()
  const location = useLocation()
  const setSelectedListing = useSetAtom(aSelectedListing)
  const client = useAtomValue(aClient)

  const listingLink = useMapListingLink(listing)

  return (
    <div
      className={cn(
        'flex min-h-full select-text flex-col bg-background pb-8 md:pb-0 lg:rounded-md lg:shadow-md',
        className
      )}>
      <div className="relative">
        <SelectionCheckbox listing={listing} />
        <Button
          className="absolute right-2 top-2 z-10 opacity-75 shadow-md transition-opacity duration-200 hover:!opacity-100"
          variant="map"
          size="map-sm"
          onClick={() => {
            // if (!isReportPage) {
            navigate(`/${location.search}`)
            // }
            setSelectedListing(null)
          }}>
          <LucideX className="h-5 w-5" />
        </Button>
        <TooltipProvider delayDuration={200}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                asChild
                variant="map"
                size="map-sm"
                className="absolute right-12 top-2 z-10 opacity-75 shadow-md transition-opacity duration-200 hover:!opacity-100">
                <Link to={listingLink} target="_blank">
                  <LucideExternalLink className="h-4 w-4" />
                </Link>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom">Open in new tab</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <ListingGallery key={listing._id} listing={listing} />
      </div>
      <div className="space-y-4 p-4 sm:p-6">
        <ListingInfo listing={listing} />
        <ListingMeta listing={listing} />
        <ListingTabs listing={listing} client={client!} />
      </div>
    </div>
  )
}
